// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2BmCR","row":"styles_row__lo5fs"};